import React from "react";
import { useHistory } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { BackButtonProps } from "./back-button.props";
import { withShowIf } from "../../../with-show-if/with-show-If.component";

export const BackButton = withShowIf((props: BackButtonProps) => {
  const history = useHistory();
  const { width = "36px", height = "36px" } = props;

  const goBack = () => {
    if (!!props.customGoBack) {
      props.customGoBack();
    } else {
      history.goBack();
    }
  };

  return (
    <IconButton
      style={{ width, height, marginLeft: "-17px", marginRight: "8px", padding: "0" }}
      onClick={goBack}
      title={"Go Back"}
    >
      <ArrowBackIosIcon style={{ width, height, marginLeft: "16px" }} />
    </IconButton>
  );
});
